"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const ListTodo = (props) => React.createElement("svg", { className: "lucide lucide-list-todo", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("rect", { x: "3", y: "5", width: "6", height: "6", rx: "1" }),
    React.createElement("path", { d: "M3 17l2 2 4-4M13 6h8M13 12h8M13 18h8" }));
exports.default = ListTodo;
